import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { configUrlForReferral } from "../constants/Config";
import {
  AuthorizationStatusDispatchTypes,
  CareCoordinationProgramDispatchTypes,
  CareTypeDispatchTypes,
  ClinicalGroupDispatchTypes,
  CreatedByDispatchTypes,
  DischargeReasonDispatchTypes,
  DisciplineRequestorDispatchTypes,
  DisciplinesDispatchTypes,
  DisciplineTemplateDispatchTypes,
  DisciplineTypeDispatchTypes,
  DiseaseTypeDispatchTypes,
  DocumentSourceDispatchTypes,
  DocumentTypeDispatchTypes,
  EligibilityRecordDispatchTypes,
  HealthPlanDispatchTypes,
  HealthProgramDispatchTypes,
  IcdCodeTypeDispatchTypes,
  MasterCallOutcomeDispatchTypes,
  NonCoveredServicesDispatchTypes,
  OrderAcceptorDispatchTypes,
  OrderingSourceDispatchTypes,
  PastMedicalHistoryDispatchTypes,
  PayerListDispatchTypes,
  PsychologicalHistoryDispatchTypes,
  ReferralServiceStatusDispatchTypes,
  PriorAuthReferralSourceDispatchTypes,
  SeriveStatusDispatchTypes,
  StaffingStatusDispatchTypes,
  ServiceStatusReasonDispatchTypes,
  ReAuthReferralSourceDispatchTypes,
  LanguageDispatchTypes,
  AccomodationDispatchTypes,
  NtuReasonMasterDispatchTypes,
  AgencyCommunicationDispatchTypes,
  AuthorizationTypeDispatchTypes,
  FaxFormDispatchTypes,
  FaxFormOptionDispatchTypes,
  LetterCopyTypeMasterDispatchTypes,
  ServiceRequestNumberMasterDispatchTypes,
  ReferralManagementSystemDispatchTypes,
  MasterSyncDispatchTypes,
  DocumentSourceForFilterDispatchTypes,
  DocumentTypeForPriorAuthDispatchTypes,
  ServiceStatusMasterDispatchTypes,
} from "../models/DispatchTypes/Master";
import {
  AuthorizationStatusActionDispatchTypes,
  CareCoordinationProgramActionDispatchTypes,
  CareTypeActionDispatchTypes,
  ClinicalGroupActionDispatchTypes,
  CreatedByActionDispatchTypes,
  DischargeReasonActionDispatchTypes,
  DisciplineRequestorActionDispatchTypes,
  DisciplinesActionDispatchTypes,
  DisciplineTemplateActionDispatchTypes,
  DisciplineTypeActionDispatchTypes,
  DiseaseTypeActionDispatchTypes,
  DocumentSourceActionDispatchTypes,
  DocumentTypeActionDispatchTypes,
  EligibilityRecordActionDispatchTypes,
  HealthPlanActionDispatchTypes,
  HealthProgramActionDispatchTypes,
  IcdCodeTypeActionDispatchTypes,
  MasterCallOutcomeActionDispatchTypes,
  NonCoveredServicesActionDispatchTypes,
  OrderAcceptorActionDispatchTypes,
  OrderingSourceActionDispatchTypes,
  PastMedicalHistoryActionDispatchTypes,
  PayerActionDispatchTypes,
  PsychologicalHistoryActionDispatchTypes,
  ReferralServiceStatusActionDispatchTypes,
  PriorAuthReferralSourceActionDispatchTypes,
  ServiceStatusActionDispatchTypes,
  StaffingStatusActionDispatchTypes,
  BenefitPlanDetailsMasterActionDispatchTypes,
  ServiceStatusReasonActionDispatchTypes,
  ReAuthReferralSourceActionDispatchTypes,
  ServiceRequestType,
  LanguageMasterActionDispatchTypes,
  AccomodationMasterActionDispatchTypes,
  NtuReasonMasterActionDispatchTypes,
  AgencyCommunicationMasterActionDispatchTypes,
  AuthorizationTypeMasterActionDispatchTypes,
  FaxFormMasterActionDispatchTypes,
  FaxFormOptionMasterActionDispatchTypes,
  LetterCopyTypeMasterActionDispatchTypes,
  ServiceRequestNumberMasterActionDispatchTypes,
  ReferralManagementSystemActionDispatchTypes,
  BenefitPlanStateMasterActionDispatchTypes,
  MasterSyncActionDispatchTypes,
  DocumentSourceForFilterActionDispatchTypes,
  DocumentTypeForPriorAuthActionDispatchTypes,
  RelationshipTypeMasterActionDispatchTypes,
  ServiceStatusMasterActionDispatchTypes,
} from "../constants/Master";
import {
  GetDiseaseTypeRespValues,
  GetAuthorizationStatusMaster,
  GetCareCoordinationProgram,
  GetCareType,
  GetClinicalGroup,
  GetDischargeReasonMaster,
  GetDisciplineRequestorMaster,
  GetDisciplines,
  GetDisciplineTemplateMaster,
  GetDisciplineType,
  GetDocumentCreatedBy,
  GetDocumentSource,
  GetDocumentType,
  GetEligibilityRecord,
  GetHealthPlanMaster,
  GetHealthProgram,
  GetMasterCallOutcome,
  GetNonCoveredService,
  GetOrderAcceptor,
  GetOrderingSource,
  GetPastMedicalHistory,
  GetPsychologicalHistory,
  GetReferralServiceStatusType,
  GetReferralSourceMaster,
  GetServiceStatusReason,
  GetStaffingStatusMaster,
  GetIcdCodeTypeData,
  GetBenefitPlanDetailsMaster,
  GetServiceStatusReasonMaster,
  GetLanguageMaster,
  GetAccomodationMaster,
  GetNtuReasonMaster,
  GetAgencyCommunicationTemplate,
  GetAuthorizationType,
  GetFaxForm,
  GetFaxFormOption,
  GetLetterCopyTypeMaster,
  GetServiceRequestNumberMaster,
  GetReferralMgmtSystem,
  GetNPPESDetailsData,
  GetEligibilityHealthPlan,
  GetServiceRequestDisciplines,
  GetBenefitPlanStatesMaster,
  MasterSyncApi,
  GetRelationshipTypeMaster,
  GetServiceStatusTypeMaster,
} from "../services/Master";
import { MasterSync, RationaleTemplatePayload } from "../models/Master";
import {
  BenefitPlanDetailsDispatchTypes,
  BenefitPlanStateDispatchTypes,
  RelationshipTypeDispatchTypes,
} from "../models/DispatchTypes/Patient";
import { DisciplineSearch } from "../models/Service";
import { GetNPPESDataActionDispatchTypes, GetOrderingNPPESDataActionDispatchTypes, GetPrimaryNPPESDataActionDispatchTypes } from "../constants/Nppes";
import { NppesSearchDispatchTypes, OrderingNppesSearchDispatchTypes, PrimaryNppesSearchDispatchTypes } from "../models/DispatchTypes/Nppes";
import { ServiceRequestDisciplinesActionDispatchTypes } from "../constants/Document";
import { ServiceRequestDisciplinesDispatchTypes } from "../models/DispatchTypes/Document";
import { updateLastSyncDateInStorage } from "../utils";
import { DataPresentInLocalStorage } from "../constants/Constants";

export const getDisciplines: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplinesDispatchTypes
  >
> = (payload?: DisciplineSearch) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplinesActionDispatchTypes.DISCIPLINES_INVOKE,
    });

    const response = await GetDisciplines(configUrlForReferral, payload);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DisciplinesActionDispatchTypes.DISCIPLINES_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DisciplinesActionDispatchTypes.DISCIPLINES_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getCareType: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    CareTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: CareTypeActionDispatchTypes.CARE_TYPE_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS,
      GetCareType,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: CareTypeActionDispatchTypes.CARE_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS,
      });
    }
  };
};

export const getPastMedicalHistory: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PastMedicalHistoryDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PastMedicalHistoryActionDispatchTypes.PAST_MEDICAL_HISTORY_INVOKE,
    });

    const response = await GetPastMedicalHistory(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: PastMedicalHistoryActionDispatchTypes.PAST_MEDICAL_HISTORY_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: PastMedicalHistoryActionDispatchTypes.PAST_MEDICAL_HISTORY_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getPsychologicalHistory: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PsychologicalHistoryDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS,
      GetPsychologicalHistory,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS,
      });
    }
  };
};

export const getMasterCallOutcome: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    MasterCallOutcomeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: MasterCallOutcomeActionDispatchTypes.MASTER_CALLOUTCOME_INVOKE,
    });

    const response = await GetMasterCallOutcome(configUrlForReferral);
   
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: MasterCallOutcomeActionDispatchTypes.MASTER_CALLOUTCOME_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: MasterCallOutcomeActionDispatchTypes.MASTER_CALLOUTCOME_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getIcdCodeTypeData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    IcdCodeTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS,
      GetIcdCodeTypeData,
      configUrlForReferral
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS,
      });
    }
  };
};

export const getDiseaseTypeCall: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DiseaseTypeDispatchTypes
  >
> = (diseaseIdentifier: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DiseaseTypeActionDispatchTypes.GET_DISEASE_TYPE_INVOKE,
    });

    const response = await GetDiseaseTypeRespValues(
      configUrlForReferral,
      diseaseIdentifier
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DiseaseTypeActionDispatchTypes.GET_DISEASE_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DiseaseTypeActionDispatchTypes.GET_DISEASE_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getReferralMgmtSystem: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralManagementSystemDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS,
      GetReferralMgmtSystem,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS,
      });
    }
  };
};

export const getHealthProgram: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    HealthProgramDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS,
      GetHealthProgram,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS,
      });
    }
  };
};

export const getCareCoordinationProgram: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    CareCoordinationProgramDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS,
      GetCareCoordinationProgram,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS,
      });
    }
  };
};

export const getNonCoveredService: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NonCoveredServicesDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS,
      GetNonCoveredService,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS,
      });
    }
  };
};

export const getOrderingSource: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    OrderingSourceDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS,
      GetOrderingSource,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS,
      });
    }
  };
};

export const getOrderAcceptor: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    OrderAcceptorDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS,
      GetOrderAcceptor,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS,
      });
    }
  };
};

// AUTH STATUS
export const getAuthorizationStatusMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AuthorizationStatusDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AuthorizationStatusActionDispatchTypes.AUTHORIZATION_STATUS_INVOKE,
    });
    const response = await GetAuthorizationStatusMaster(configUrlForReferral);

    dispatch({
      response,
      type: AuthorizationStatusActionDispatchTypes.AUTHORIZATION_STATUS_SUCCESS,
    });

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: AuthorizationStatusActionDispatchTypes.AUTHORIZATION_STATUS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: AuthorizationStatusActionDispatchTypes.AUTHORIZATION_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

// Referral Source

export const getPriorAuthReferralSourceMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PriorAuthReferralSourceDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS,
      GetReferralSourceMaster,
      configUrlForReferral,
      ServiceRequestType.AUTH_ID
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS,
      });
    }
  };
};

export const getReAuthReferralSourceMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReAuthReferralSourceDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReAuthReferralSourceActionDispatchTypes.RE_AUTH_REFERRAL_SOURCE_INVOKE,
    });
    const response = await GetReferralSourceMaster(
      configUrlForReferral,
      ServiceRequestType.RE_AUTH_ID
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ReAuthReferralSourceActionDispatchTypes.RE_AUTH_REFERRAL_SOURCE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response:response.data,
            type: ReAuthReferralSourceActionDispatchTypes.RE_AUTH_REFERRAL_SOURCE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

// Staffing Status

export const getStaffingStatusMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    StaffingStatusDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: StaffingStatusActionDispatchTypes.STAFFING_STATUS_INVOKE,
    });

    const response = await GetStaffingStatusMaster(configUrlForReferral);

    dispatch({
      response,
      type: StaffingStatusActionDispatchTypes.STAFFING_STATUS_SUCCESS,
    });

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: StaffingStatusActionDispatchTypes.STAFFING_STATUS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: StaffingStatusActionDispatchTypes.STAFFING_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDischargeReasonMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DischargeReasonDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DischargeReasonActionDispatchTypes.DISCHARGE_REASON_INVOKE,
    });

    const response = await GetDischargeReasonMaster(configUrlForReferral);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            response,
            type: DischargeReasonActionDispatchTypes.DISCHARGE_REASON_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DischargeReasonActionDispatchTypes.DISCHARGE_REASON_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDocumentType: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentTypeDispatchTypes
  >
> = (excludeLetter: boolean, isForFilter: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_INVOKE,
    });

    const response = await GetDocumentType(
      configUrlForReferral,
      excludeLetter,
      isForFilter
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            response,
            type: DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DocumentTypeActionDispatchTypes.GET_DOCUMENT_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDocumentTypeForPriorAuth: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentTypeForPriorAuthDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS,
      GetDocumentType,
      configUrlForReferral,
      true,
      false
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            response,
            type: DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS,
      });
    }
  };
};

export const getDocumentSourceForFilter: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentSourceForFilterDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentSourceForFilterActionDispatchTypes.GET_DOCUMENT_SOURCE_FOR_FILTER_INVOKE,
    });

    const response = await GetDocumentSource(configUrlForReferral, true);
    dispatch({
      response: response,
      type: DocumentSourceForFilterActionDispatchTypes.GET_DOCUMENT_SOURCE_FOR_FILTER_SUCCESS,
    });
  };
};

export const getDocumentSource: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DocumentSourceDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS,
      GetDocumentSource,
      configUrlForReferral,
      false
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS,
      });
    }
  };
};

export const getDocumentCreatedBy: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    CreatedByDispatchTypes
  >
> = (searchText: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: CreatedByActionDispatchTypes.CREATED_BY_INVOKE,
    });

    const response = await GetDocumentCreatedBy(
      configUrlForReferral,
      searchText
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: CreatedByActionDispatchTypes.CREATED_BY_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: CreatedByActionDispatchTypes.CREATED_BY_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getReferralServiceStatusResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ReferralServiceStatusDispatchTypes
  >
> = (requiredIncompleteOption: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_INVOKE,
    });

    const response = await GetReferralServiceStatusType(
      configUrlForReferral,
      requiredIncompleteOption
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getServiceStatusMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ServiceStatusMasterDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS,
      GetServiceStatusTypeMaster,
      configUrlForReferral,
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS,
      });
    }
  };
};

/**new filter */
export const getServiceStatusReasonMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ServiceStatusReasonDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_INVOKE,
    });

    const response = await updateLastSyncDateInStorage(
      ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS,
      GetServiceStatusReasonMaster,
      configUrlForReferral
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    } else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS,
      });
    }
  };
};

export const getDisciplineTypeResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplineTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplineTypeActionDispatchTypes.DISCIPLINE_TYPE_INVOKE,
    });

    const response = await GetDisciplineType(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DisciplineTypeActionDispatchTypes.DISCIPLINE_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DisciplineTypeActionDispatchTypes.DISCIPLINE_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getServiceStatusReasonResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    SeriveStatusDispatchTypes
  >
  > = (serviceId: number, isRetro: boolean, serviceRequestId?: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceStatusActionDispatchTypes.SERVICE_STATUS_INVOKE,
    });

    const response = await GetServiceStatusReason(
      configUrlForReferral,
      serviceId,
      isRetro,
      serviceRequestId,
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ServiceStatusActionDispatchTypes.SERVICE_STATUS_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ServiceStatusActionDispatchTypes.SERVICE_STATUS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDisciplineTemplateResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplineTemplateDispatchTypes
  >
> = (payload: RationaleTemplatePayload) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplineTemplateActionDispatchTypes.DISCIPLINE_TEMPLATE_INVOKE,
    });

    const response = await GetDisciplineTemplateMaster(
      configUrlForReferral,
      payload
    );
  
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DisciplineTemplateActionDispatchTypes.DISCIPLINE_TEMPLATE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DisciplineTemplateActionDispatchTypes.DISCIPLINE_TEMPLATE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getDisciplineRequestorResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    DisciplineRequestorDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: DisciplineRequestorActionDispatchTypes.DISCIPLINE_REQUESTOR_INVOKE,
    });

    const response = await GetDisciplineRequestorMaster(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: DisciplineRequestorActionDispatchTypes.DISCIPLINE_REQUESTOR_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: DisciplineRequestorActionDispatchTypes.DISCIPLINE_REQUESTOR_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getClinicalGroup: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ClinicalGroupDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ClinicalGroupActionDispatchTypes.CLINICAL_GROUP_INVOKE,
    });
    const response = await GetClinicalGroup(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ClinicalGroupActionDispatchTypes.CLINICAL_GROUP_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ClinicalGroupActionDispatchTypes.CLINICAL_GROUP_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getMasterEligibilityPayer: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PayerListDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: PayerActionDispatchTypes.PAYER_INVOKE,
    });

    const response = await GetEligibilityHealthPlan(configUrlForReferral);
    
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: PayerActionDispatchTypes.PAYER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: PayerActionDispatchTypes.PAYER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getEligibilityRecord: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    EligibilityRecordDispatchTypes
  >
> = (benefitPlanUid: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: EligibilityRecordActionDispatchTypes.ELIGIBILITY_RECORD_INVOKE,
    });
    const response = await GetEligibilityRecord(
      configUrlForReferral,
      benefitPlanUid
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: EligibilityRecordActionDispatchTypes.ELIGIBILITY_RECORD_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: EligibilityRecordActionDispatchTypes.ELIGIBILITY_RECORD_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getHealthPlanMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    HealthPlanDispatchTypes
  >
> = (filter?: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_INVOKE,
    });
    const response = await GetHealthPlanMaster(configUrlForReferral, filter);
    
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: HealthPlanActionDispatchTypes.HEALTH_PLAN_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const GetBenefitPlanDetailsMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    BenefitPlanDetailsDispatchTypes
  >
> = (healthPlanId: number, state: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_INVOKE,
    });
    const response = await GetBenefitPlanDetailsMaster(
      configUrlForReferral,
      healthPlanId,
      state
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: BenefitPlanDetailsMasterActionDispatchTypes.BENEFIT_PLAN_DETAILS_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getBenefitPlanStatesMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    BenefitPlanStateDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_INVOKE,
    });
    const response = await GetBenefitPlanStatesMaster(configUrlForReferral);

    dispatch({
      response,
      type: BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_SUCCESS,
    });

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: BenefitPlanStateMasterActionDispatchTypes.BENEFIT_PLAN_STATE_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getRelationshipTypeMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    RelationshipTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: RelationshipTypeMasterActionDispatchTypes.RELATIONSHIP_TYPE_MASTER_INVOKE,
    });
    const response = await GetRelationshipTypeMaster(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: RelationshipTypeMasterActionDispatchTypes.RELATIONSHIP_TYPE_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: RelationshipTypeMasterActionDispatchTypes.RELATIONSHIP_TYPE_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const GetLanguageMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    LanguageDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS,
      GetLanguageMaster,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS,
      });
    }
  };
};

export const GetAccomodationMasterResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AccomodationDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS,
      GetAccomodationMaster,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS,
      });
    }
  };
};

export const GetNtuReasonMasterResponse: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NtuReasonMasterDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_INVOKE,
    });

    const response = await GetNtuReasonMaster(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const GetAgencyTemplateMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AgencyCommunicationDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AgencyCommunicationMasterActionDispatchTypes.GET_AGENCY_COMMUNICATION_TEMPLATE_INVOKE,
    });

    const response = await GetAgencyCommunicationTemplate(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: AgencyCommunicationMasterActionDispatchTypes.GET_AGENCY_COMMUNICATION_TEMPLATE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: AgencyCommunicationMasterActionDispatchTypes.GET_AGENCY_COMMUNICATION_TEMPLATE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getAuthorizationTypeMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    AuthorizationTypeDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_INVOKE,
    });
    const response = await updateLastSyncDateInStorage(
      AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS,
      GetAuthorizationType,
      configUrlForReferral
    );
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }else if (response.message === DataPresentInLocalStorage) {
      dispatch({
        response: response.data,
        type: AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS,
      });
    }
  };
};

export const getFaxFormMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    FaxFormDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: FaxFormMasterActionDispatchTypes.GET_FAX_FORM_MASTER_INVOKE,
    });

    const response = await GetFaxForm(configUrlForReferral);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: FaxFormMasterActionDispatchTypes.GET_FAX_FORM_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: FaxFormMasterActionDispatchTypes.GET_FAX_FORM_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};
export const getLetterCopyTypeMasterResponse: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    LetterCopyTypeMasterDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: LetterCopyTypeMasterActionDispatchTypes.GET_LETTER_COPY_TYPE_MASTER_INVOKE,
    });

    const response = await GetLetterCopyTypeMaster(configUrlForReferral);
    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: LetterCopyTypeMasterActionDispatchTypes.GET_LETTER_COPY_TYPE_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: LetterCopyTypeMasterActionDispatchTypes.GET_LETTER_COPY_TYPE_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getFaxFormOptionMaster: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    FaxFormOptionDispatchTypes
  >
> = (formId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: FaxFormOptionMasterActionDispatchTypes.GET_FAX_FORM_OPTION_MASTER_INVOKE,
    });

    const response = await GetFaxFormOption(configUrlForReferral, formId);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: FaxFormOptionMasterActionDispatchTypes.GET_FAX_FORM_OPTION_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: FaxFormOptionMasterActionDispatchTypes.GET_FAX_FORM_OPTION_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getServiceRequestNumberMasterResponse: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ServiceRequestNumberMasterDispatchTypes
  >
> = (referralId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceRequestNumberMasterActionDispatchTypes.GET_SERVICE_REQUEST_NUMBER_MASTER_INVOKE,
    });
    const response = await GetServiceRequestNumberMaster(
      configUrlForReferral,
      referralId
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ServiceRequestNumberMasterActionDispatchTypes.GET_SERVICE_REQUEST_NUMBER_MASTER_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ServiceRequestNumberMasterActionDispatchTypes.GET_SERVICE_REQUEST_NUMBER_MASTER_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getServiceRequestDisciplines: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ServiceRequestDisciplinesDispatchTypes
  >
> = (serviceRequestId: number) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_INVOKE,
    });

    const response = await GetServiceRequestDisciplines(
      configUrlForReferral,
      serviceRequestId
    );

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: ServiceRequestDisciplinesActionDispatchTypes.GET_SERVICE_REQUEST_DISCIPLINES_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getNPPEsDetailsData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    NppesSearchDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_INVOKE,
    });

    const response = await GetNPPESDetailsData(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: GetNPPESDataActionDispatchTypes.GET_NPPES_DATA_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getOrderingNPPESDetailsData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    OrderingNppesSearchDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_INVOKE,
    });

    const response = await GetNPPESDetailsData(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: GetOrderingNPPESDataActionDispatchTypes.GET_ORDERING_NPPES_DATA_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getPrimaryNPPESDetailsData: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    PrimaryNppesSearchDispatchTypes
  >
> = (payload: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_INVOKE,
    });

    const response = await GetNPPESDetailsData(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
        case 500:
          dispatch({
            type: GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_ERROR,
          });
          break;
        case 200:
          dispatch({
            response: response.data,
            type: GetPrimaryNPPESDataActionDispatchTypes.GET_PRIMARY_NPPES_DATA_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const masterSync: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    MasterSyncDispatchTypes
  >
> = (payload: MasterSync[]) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: MasterSyncActionDispatchTypes.MASTER_SYNC_INVOKE,
    });
    const response = await MasterSyncApi(configUrlForReferral, payload);

    if (response && response.status) {
      switch (response.status) {
        case 422:
        case 400:
        case 404:
          dispatch({
            type: MasterSyncActionDispatchTypes.MASTER_SYNC_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: MasterSyncActionDispatchTypes.MASTER_SYNC_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};
